/**
 * PageHeader Component - Reusable page header with title, description, and actions
 */
import { memo } from 'react';
import React from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode[];
}

const PageHeader = memo(({
  title,
  description,
  actions
}: PageHeaderProps) => {
  return (
    <div className="flex items-start justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground mb-1">{title}</h1>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {actions && actions.length > 0 && (
        <div className="flex items-center gap-2">
          {actions.map((action: React.ReactNode, index: number) => (
            <div key={index}>{action}</div>
          ))}
        </div>
      )}
    </div>
  );
});

PageHeader.displayName = 'PageHeader';

export default PageHeader;
